export const placeOptions = [
  'Hela Sverige',
  'Blekinge',
  'Dalarna',
  'Gotland',
  'Gävleborg',
  'Göteborg',
  'Halland',
  'Jämtland',
  'Jönköping',
  'Kalmar',
  'Kronoberg',
  'Norrbotten',
  'Skaraborg',
  'Skåne',
  'Stockholm',
  'Stockholm, centralt',
  'Stockholm, norra',
  'Stockholm, södra',
  'Södermanland',
  'Uppsala',
  'Värmland',
  'Västerbotten',
  'Västernorrland',
  'Västmanland',
  'Älvsborg',
  'Örebro',
  'Östergötland',
  'Utomlands'
].map(s => {
  const value = s.replace(/å/g, 'a').replace(/Å/g, 'A').replace(/ä/g, 'a').replace(/Ä/g, 'A').replace(/ö/g, 'o').replace(/Ö/g, 'O');
  const label = s === 'Utomlands' ? 'Utomlands / Other' : s;
  return { label, value };
});

export const placeLabel = (value: string) =>
  placeOptions.find(option => option.value === value)?.label ?? value;
